<template>
  <div :class="cardClass">
    <div
      class="card-body px-4 pt-4"
      :class="cardBodyClass"
    >
      <div
        class="d-flex"
      >
        <div class="company-image">
          <img
            v-if="companyLogo == ''"
            id="logo"
            alt="Company Logo"
            :src="defaultImage"
          >
          <img
            v-else
            id="logo"
            alt="Company Logo"
            :src="companyLogo"
          >
        </div>
        <div class="d-flex justify-content-between w-100 pl-3 pl-md-4">
          <div class="left-wrapper">
            <h3 class="mb-0 font-large font-weight-bold">
              <a
                v-if="activeCard"
                id="company-name"
                :href="companyDetailPath"
              >
                {{ companyName }}
              </a>
              <span
                v-else
                id="company-name"
              >
                {{ companyName }}
              </span>
            </h3>
            <p
              v-if="businessCategories.length === 0"
              id="business-categories"
              class="d-inline-block mb-1 text-gray03"
            >
              {{ t('business_categories') + t('unsettled') }}
            </p>
            <p
              v-else
              id="business-categories"
              class="d-inline-block mb-1 text-dark-gray"
            >
              {{ businessCategories.join('、 ') }}
            </p>
            <div
              class="d-block mb-1"
              :class="(indexPageFlg) ? 'mb-md-3' : 'mb-md-1'"
            >
              <i class="material-icons md-gray cursor-default"> chat_bubble </i>
              <span class="align-top text-dark-gray"> {{ reviewNumber }}件の口コミ </span>
            </div>
          </div>
          <div
            class="d-none pb-3 pl-3"
            :class="favoriteButtonRightClass"
          >
            <div class="mb-3">
              <error-message
                :errors="errorMessages"
              /><!-- 一時的措置 -->
            </div>
          </div>
          <!-- <div
            class="d-block d-sm-flex"
            :class="indexPageFlg ? 'mb-3' : 'mb-1'"
          > -->
          <!-- TODO: 星レート再表示 -->
          <!-- <star-rating
                v-model="rateNumber"
                :increment="0.01"
                :max-rating="5"
                :read-only="true"
                :show-rating="showRatingFlg"
                :fixed-points="2"
                :star-size="18"
                inactive-color="#b8c2cc"
                active-color="#ffbb00"
                text-class="text-primary font-weight-bold font-title mt-0"
                :inline="false"
                :padding="4"
              /> -->
          <!-- https://www.npmjs.com/package/vue-star-rating -->
          <!-- </div> -->
        </div>
      </div>
      <!-- adminの企業編集の確認モーダルで要素が存在している必要がある -->
      <p
        v-if="selfExpression"
        id="self-expression"
        class="mb-5 font-small text-dark-gray"
        :class="{ 'ml-image-size': selfExpression }"
      >
        {{ selfExpression }}
      </p>
      <v-separator
        v-if="detailPageFlg"
        class="w-100"
        :class="{ 'mt-4': detailPageFlg }"
      />
      <div
        :class="tagsPlacement"
      >
        <p class="mb-1 mr-4 text-dark-gray font-small service-tags-label">
          {{ t('service_tags') }}
        </p>
        <span
          v-if="serviceTags.length > 0"
          id="service-tags"
          class="btn-group d-block mb-1 flex-1"
        >
          <inline-tags-list :tags-array="serviceTags" />
        </span>
        <p
          v-else
          id="service-tags"
          class="btn-group text-gray03"
        >
          {{ t('unsettled') }}
        </p>
      </div>
      <div
        v-if="serviceIntroduction"
        class="mb-4 mb-md-0"
      >
        <span
          id="service-introduction"
          class="word-wrap"
          v-text="serviceIntroduction"
        />
      </div>
    </div>
  </div>
</template>

<script>

// import StarRating from "vue-star-rating";
import VSeparator from "../surveys/VSeparator.vue";
import ErrorMessage from "../surveys/ErrorMessage.vue";
import InlineTagsList from "../companies/InlineTagsList.vue";
import axios from "axios";
import I18n from "../../i18n/i18n";
import "../../i18n/ja";
import { i18n } from "../../mixins/i18n";

// eslint-disable-next-line node/no-unsupported-features
export default {
  components: {

    // StarRating,
    VSeparator,
    ErrorMessage,
    InlineTagsList
  },
  mixins: [i18n],
  props: {
    companyId: {
      type: Number,
      required: true
    },
    companyName: {
      type: String,
      required: true
    },
    companyLogo: {
      type: String,
      default: ""
    },
    companyDetailPath: {
      type: String,
      default: "#"
    },
    businessCategories: {
      type: Array,
      default() {
        return [];
      }
    },
    serviceTags: {
      type: Array,
      default() {
        return [];
      }
    },
    industryTags: {
      type: Array,
      default() {
        return [];
      }
    },
    rateNumber: {
      type: Number,
      default: 0
    },
    reviewNumber: {
      type: Number,
      default: 0
    },
    activeCard: {
      type: Boolean,
      default: false
    },
    serviceIntroduction: {
      type: String,
      default: ""
    },
    selfExpression: {
      type: String,
      default: ""
    },
    indexPageFlg: {
      type: Boolean,
      default: false
    },
    detailPageFlg: {
      type: Boolean,
      default: false
    },
    disabledFlg: {
      type: Boolean,
      default: false
    },
    companyHeadFlg: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      flg: false,
      errorMessages: [],
      defaultImage: require("../../../../assets/images/no_logo.png"),
      showRatingFlg: true,
      cardClass: {
        card: this.activeCard,
        "wide-card": this.activeCard,
        "mb-3 mb-md-6": this.activeCard && !this.isLast
      },
      cardBodyClass: {
        "pb-4": this.indexPageFlg,
        "pb-3": this.detailPageFlg,
        "px-md-9": this.indexPageFlg || this.detailPageFlg,
        "pb-md-6": this.indexPageFlg || this.detailPageFlg,
        "pt-md-8": this.indexPageFlg || this.detailPageFlg
      },
      tagsPlacement: {
        "ml-image-size": this.indexPageFlg,
        "pt-4": this.detailPageFlg,
        "pt-mb-6": this.detailPageFlg,
        "d-md-flex": this.indexPageFlg
      },
      favoriteButtonRightClass: {
        "d-md-inline-block": this.indexPageFlg || this.detailPageFlg,
        disabled: this.disabledFlg,
        "can-not-click": this.disabledFlg
      }
    };
  },
  mounted() {
    axios.defaults.headers["X-CSRF-TOKEN"] = document.getElementsByName("csrf-token")[0].content;
    axios.defaults.headers.X_REQUESTED_WITH = "XMLHttpRequest";
    this.flg = this.favoriteFlg;
    if (this.rateNumber === 0) {
      this.showRatingFlg = false;
    }
  }
};
</script>

<style scoped>
.card-style-none {
  box-shadow: none;
  border: none !important;
}
.service-tags-label {
  width: 72px;
}
.cursor-default {
  cursor: default;
}
.word-wrap {
  white-space: pre-wrap;
  word-wrap: break-word;
}
#logo {
  max-width: 80px;
}
.ml-image-size {
  margin-left: 101px;
}
@media (max-width: 991px) {
  .w-lg-100 {
    width: 100%;
  }
}
@media (max-width: 767px) {
  h3.font-large {
    font-size: 1rem !important;
  }
  #logo {
    max-width: 50px;
  }
  .ml-image-size {
    margin-left: 0;
  }
  .pc-display-on {
    display: none;
  }
  .card-margin {
    margin-bottom: 1rem !important;
  }
  .add-pb-xs-2px {
    margin-bottom: 2px;
  }
}
  @media (min-width: 768px) {
  .sm-display-on {
    display: none;
  }
  .card-margin {
    margin-bottom: 2rem !important;
  }
}
</style>
